
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 612.099 612.099"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M573.794 564.26c0 5.28-4.284 9.563-9.564 9.563-5.279 0-9.563-4.283-9.563-9.563V248.666H353.88a9.582 9.582 0 01-7.232-3.308l-34.969-34.949H19.178v382.543h573.744V277.358c0-5.28 4.284-9.564 9.562-9.564 5.28 0 9.564 4.304 9.564 9.564v325.178c0 5.26-4.284 9.562-9.564 9.562H9.614c-5.28 0-9.564-4.283-9.564-9.562V200.845c0-5.28 4.284-9.564 9.564-9.564h305.97v.04c2.431 0 4.86.937 6.715 2.77l35.486 35.447H564.21c5.279 0 9.562 4.304 9.562 9.564V564.26h.022z"}}),_c('path',{attrs:{"d":"M38.306 162.569c0 5.28-4.284 9.564-9.564 9.564s-9.564-4.284-9.564-9.564V9.564c0-5.28 4.284-9.564 9.564-9.564H392.097c5.28 0 9.563 4.284 9.563 9.564v191.261c0 5.28-4.283 9.564-9.563 9.564s-9.563-4.284-9.563-9.564V19.128H38.306v143.441z"}}),_c('path',{attrs:{"d":"M105.255 76.533c-5.28 0-9.564-4.284-9.564-9.564s4.284-9.563 9.564-9.563h210.349c5.28 0 9.564 4.304 9.564 9.563 0 5.28-4.284 9.564-9.564 9.564H105.255zM506.865 76.533c-5.28 0-9.564-4.284-9.564-9.564s4.284-9.563 9.564-9.563h38.256c5.279 0 9.563 4.304 9.563 9.563v133.857c0 5.28-4.284 9.564-9.563 9.564-5.28 0-9.563-4.284-9.563-9.564V76.533h-28.693zM105.255 153.065c-5.28 0-9.564-4.284-9.564-9.564s4.284-9.564 9.564-9.564h210.349c5.28 0 9.564 4.284 9.564 9.564s-4.284 9.564-9.564 9.564H105.255zM430.312 57.424c-5.279 0-9.562-4.284-9.562-9.564s4.283-9.564 9.562-9.564h38.296c5.262 0 9.564 4.284 9.564 9.564v152.945c0 5.28-4.284 9.564-9.564 9.564-5.278 0-9.562-4.284-9.562-9.564V57.424h-28.734z"}})])
          )
        }
      }
    